import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-12" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Configuration number to connect")
  ])
], -1)
const _hoisted_5 = { class: "row w-100" }
const _hoisted_6 = { class: "col-12 col-md-8 col-lg-10 my-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted h6 font-weight-normal mt-2" }, " Insert phone number without symbols (+, -, etc) or spaces ", -1)
const _hoisted_8 = { class: "col-12 col-md-4 col-lg-2 my-1" }
const _hoisted_9 = { class: "d-flex flex-row" }
const _hoisted_10 = { class: "d-flex align-items-center my-1" }
const _hoisted_11 = {
  key: 1,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Save ")

import { computed, ref, onMounted } from "vue";
import { AlertModule } from "@/store/modules/Alert";
import { iInvalidSubmit } from "@/composables/vee-validate";
import { IndexType } from "@/types/store";
import { Field } from "@/types/components";
import { Form, FormActions } from "vee-validate";
import { List } from "@element-plus/icons";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import { dialerApi } from "@/conection/index";
import { formatNumber } from "@/util/utils.ts";

import * as yup from "yup";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const form = ref<IndexType<Field>>({});
const number1Ref = ref("");
const formkey = ref(0);
const formComponent = ref<
	| (FormActions<any> & {
			getValues: () => { [k: string]: string | undefined };
	  })
	| null
>(null);
onMounted(async () => {
	loading.value = true;
	try {
		const response = await dialerApi.get("/api-config");
		if (response.status === 200) {
			number1Ref.value = response?.data?.from?.number?.replace(/^00/, "");
		}
	} catch (error) {
		loading.value = false;
	}

	loading.value = false;
});
const loading = ref(false);
//computed
const schema = yup.object({
	number1: yup.string().matches(/[0-9]{3,}/, "Phone number is not valid"),
});

async function onSubmit(values: any) {
	loading.value = true;
	try {
		const response = await dialerApi.put("/api-config/update", {
			from: {
				number:
					values?.number1?.length > 5 ? formatNumber(values.number1) : values.number1,
				...(values?.number1?.length > 5 && {
					context: "llamada_saliente_internacional",
				}),
			},
		});
		if (response.status === 200) {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Configuration saved successfully`,
				type: "success",
			});
		} else {
			AlertModule.SOCKET_PUSH_NOTIFICATION({
				text: `Error// Configuration has not been saved`,
				type: "error",
			});
		}
	} catch (error) {
		loading.value = false;

		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: `Error// Configuration has not been saved`,
			type: "error",
		});
	}

	loading.value = false;
}

function onInvalidSubmit(values: iInvalidSubmit) {
	const errMsgs: string[] = Object.keys(values.errors);

	AlertModule.SOCKET_PUSH_NOTIFICATION({
		text: `Please Check ${errMsgs.join()}`,
		type: "error",
	});
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_card, { "header-classes": "bg-transparent" }, {
            header: _withCtx(() => [
              _hoisted_4
            ]),
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_unref(Form), {
                class: "w-100 form-inline",
                ref_key: "formComponent",
                ref: formComponent,
                key: formkey.value,
                "validation-schema": _unref(schema),
                onSubmit: _cache[0] || (_cache[0] = (e) => onSubmit(e)),
                onInvalidSubmit: onInvalidSubmit
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(BaseInput, {
                        name: "number1",
                        label: "Phone number 1",
                        placeholder: "22505555",
                        "label-classes": "text-muted h5 font-weight-normal mr-3",
                        "addon-left-icon": "fas fa-phone",
                        alternative: "",
                        inputGroupClasses: "w-75",
                        value: number1Ref.value
                      }, {
                        infoBlock: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_base_button, {
                          disabled: loading.value,
                          "native-type": "submit"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              (!loading.value)
                                ? (_openBlock(), _createBlock(_component_el_icon, {
                                    key: 0,
                                    size: 20,
                                    color: "#FFFFF",
                                    class: "no-inherit"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(List))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (loading.value)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                                : _createCommentVNode("", true),
                              _hoisted_12
                            ])
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema"]))
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})